(() => {
  if (window.__moretroQuoteApprovalInstalled) return;
  window.__moretroQuoteApprovalInstalled = true;

  const nativeFetch = window.fetch.bind(window);
  const css = `
  .mrqa-backdrop{position:fixed;inset:0;z-index:2147483646;background:rgba(3,5,10,.78);backdrop-filter:blur(12px);display:grid;place-items:center;padding:18px;font-family:Arial,sans-serif}
  .mrqa-modal{width:min(820px,100%);max-height:90vh;overflow:auto;color:#f8f8fb;background:#0d111b;border:1px solid #343b4d;border-radius:22px;box-shadow:0 30px 100px rgba(0,0,0,.5)}
  .mrqa-head,.mrqa-body{padding:20px}.mrqa-head{display:flex;justify-content:space-between;align-items:center;border-bottom:1px solid #2b3140}.mrqa-head h2{margin:0;font-size:23px}.mrqa-close{border:0;background:#242a37;color:white;border-radius:50%;width:38px;height:38px;font-size:22px;cursor:pointer}
  .mrqa-drop{display:grid;place-items:center;text-align:center;padding:25px;border:1px dashed #596176;border-radius:15px;background:#111623;cursor:pointer}.mrqa-drop input{display:none}.mrqa-grid{display:grid;grid-template-columns:repeat(auto-fit,minmax(170px,1fr));gap:12px;margin:16px 0}.mrqa-item{border:1px solid #343b4d;border-radius:14px;overflow:hidden;background:#090c13}.mrqa-item img{width:100%;aspect-ratio:4/3;object-fit:contain;display:block}.mrqa-item input{width:100%;padding:10px;border:0;border-top:1px solid #343b4d;background:#121722;color:white}.mrqa-row{display:flex;gap:10px;justify-content:flex-end;flex-wrap:wrap}.mrqa-btn{border:0;border-radius:12px;padding:13px 17px;color:white;background:#282e3b;font-weight:700;cursor:pointer}.mrqa-primary{background:linear-gradient(90deg,#ff304f,#922cff,#05c8f5)}.mrqa-note{color:#aeb5c3;line-height:1.55}.mrqa-error{color:#ff8290;margin:10px 0}.mrqa-loading{opacity:.6;pointer-events:none}@media(max-width:520px){.mrqa-row .mrqa-btn{width:100%}}
  `;
  const style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function fileToImage(file) {
    return new Promise((resolve, reject) => {
      if (!/^image\/(jpeg|png|webp)$/.test(file.type)) return reject(new Error('Format image non accepté.'));
      const reader = new FileReader();
      reader.onerror = reject;
      reader.onload = () => {
        const image = new Image();
        image.onerror = reject;
        image.onload = () => {
          const scale = Math.min(1, 1280 / Math.max(image.width, image.height));
          const canvas = document.createElement('canvas');
          canvas.width = Math.max(2, Math.round(image.width * scale));
          canvas.height = Math.max(2, Math.round(image.height * scale));
          canvas.getContext('2d').drawImage(image, 0, 0, canvas.width, canvas.height);
          let quality = .78;
          let dataUrl = canvas.toDataURL('image/jpeg', quality);
          while (dataUrl.length > 140000 && quality > .28) {
            quality -= .08;
            dataUrl = canvas.toDataURL('image/jpeg', quality);
          }
          if (dataUrl.length > 155000) return reject(new Error('Image encore trop lourde après compression.'));
          resolve({ contentType:'image/jpeg', dataBase64:dataUrl.split(',')[1], caption:file.name.replace(/\.[^.]+$/, '') });
        };
        image.src = reader.result;
      };
      reader.readAsDataURL(file);
    });
  }

  function openApproval(project, endpoint) {
    return new Promise((resolve, reject) => {
      const backdrop = document.createElement('div');
      backdrop.className = 'mrqa-backdrop';
      backdrop.innerHTML = `<section class="mrqa-modal" role="dialog" aria-modal="true" aria-label="Envoyer le devis visuel"><header class="mrqa-head"><div><h2>Validation visuelle du devis</h2><div class="mrqa-note">${project.projectType || project.title || 'Projet sur mesure'} · ${Number(project.price || project.finalPrice || 0).toFixed(2).replace('.', ',')} €</div></div><button class="mrqa-close" aria-label="Fermer">×</button></header><div class="mrqa-body"><label class="mrqa-drop">Ajouter les rendus de modélisation<br><small class="mrqa-note">JPG, PNG ou WebP · 6 images maximum</small><input type="file" accept="image/jpeg,image/png,image/webp" multiple></label><div class="mrqa-grid"></div><p class="mrqa-note">Le client recevra un lien sécurisé pour accepter, demander une modification ou refuser. Le paiement Shopify sera proposé uniquement après acceptation.</p><div class="mrqa-error"></div><div class="mrqa-row"><button class="mrqa-btn mrqa-cancel">Annuler</button><button class="mrqa-btn mrqa-primary mrqa-send">Envoyer pour validation</button></div></div></section>`;
      document.body.appendChild(backdrop);
      const modal = backdrop.querySelector('.mrqa-modal');
      const input = backdrop.querySelector('input[type=file]');
      const grid = backdrop.querySelector('.mrqa-grid');
      const error = backdrop.querySelector('.mrqa-error');
      const images = [];
      const close = () => { backdrop.remove(); reject(new DOMException('Envoi annulé', 'AbortError')); };
      backdrop.querySelector('.mrqa-close').onclick = close;
      backdrop.querySelector('.mrqa-cancel').onclick = close;
      input.onchange = async () => {
        error.textContent = '';
        try {
          for (const file of [...input.files].slice(0, 6 - images.length)) images.push(await fileToImage(file));
          grid.innerHTML = '';
          images.forEach((item, index) => {
            const node = document.createElement('div');
            node.className = 'mrqa-item';
            node.innerHTML = `<img alt="Rendu ${index + 1}" src="data:${item.contentType};base64,${item.dataBase64}"><input aria-label="Légende du rendu ${index + 1}" value="${item.caption.replaceAll('&','&amp;').replaceAll('"','&quot;')}">`;
            node.querySelector('input').oninput = event => item.caption = event.target.value;
            grid.appendChild(node);
          });
        } catch (err) { error.textContent = err.message; }
        input.value = '';
      };
      backdrop.querySelector('.mrqa-send').onclick = async () => {
        if (!images.length) { error.textContent = 'Ajoute au moins un rendu de modélisation.'; return; }
        error.textContent = '';
        modal.classList.add('mrqa-loading');
        try {
          const response = await nativeFetch(endpoint, { method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({ project, images }) });
          const clone = response.clone();
          const payload = await clone.json().catch(() => ({}));
          if (!response.ok || payload.ok === false) throw new Error(payload.error || 'Envoi impossible.');
          backdrop.remove();
          resolve(response);
        } catch (err) {
          modal.classList.remove('mrqa-loading');
          error.textContent = err.message;
        }
      };
    });
  }

  window.fetch = async function(input, init = {}) {
    const url = typeof input === 'string' ? input : input?.url || '';
    if (!/\/api\/shopify\/send-quote(?:\?|$)/.test(url)) return nativeFetch(input, init);
    try {
      const body = typeof init.body === 'string' ? JSON.parse(init.body) : {};
      const project = body.project || {};
      const base = new URL(url, window.location.href).origin;
      return await openApproval(project, `${base}/api/quotes/send-for-approval`);
    } catch (error) {
      if (error?.name === 'AbortError') throw error;
      return nativeFetch(input, init);
    }
  };
})();
